import { saveState } from './saveState'
import config from '../config'

const saveToken = (token) => {
  localStorage.setItem('savedTokenForTabSync', JSON.stringify(token))
  saveState(config.token_name, token)
}

export { saveToken }
